import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchParticipationTransactionsApi, startOperationApi, endOperationApi, absentApi } from "./ptApi";

const getErrorMessage = (error, defaultMsg) => {
  if (error.response?.data) {
    const data = error.response.data;
    if (typeof data === "string") return data;
    return data.ExceptionMessage || data.message || data.title || defaultMsg;
  }
  return "Bağlantı hatası";
};

export const fetchDailyTransactions = createAsyncThunk(
  "participationTransactions/fetchDaily",
  async ({ branchId, year, month, currentDate }, { rejectWithValue }) => {
    try {
      const data = await fetchParticipationTransactionsApi(branchId, year, month, currentDate);
      return data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Devam kayıtları alınamadı."));
    }
  }
);

export const startOperation = createAsyncThunk(
  "participationTransactions/startOperation",
  async ({ employeeId, startTime }, { rejectWithValue }) => {
    try {
      const data = await startOperationApi(employeeId, startTime);
      return { employeeId, startTime, transaction: data };
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "İşlem başlatılamadı."));
    }
  }
);

export const endOperation = createAsyncThunk(
  "participationTransactions/endOperation",
  async ({ employeeId, participationTransactionId, endTime }, { rejectWithValue }) => {
    try {
      const data = await endOperationApi(participationTransactionId, endTime);
      return { employeeId, participationTransactionId, endTime, result: data };
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "İşlem sonlandırılamadı."));
    }
  }
);

export const absentOperation = createAsyncThunk(
  "participationTransactions/absent",
  async ({ employeeId, absentAt, description, reasonType }, { rejectWithValue }) => {
    try {
      const data = await absentApi(employeeId, absentAt, description, reasonType);
      return { employeeId, absentAt, description, reasonType, result: data };
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Gelmedi işlemi başarısız."));
    }
  }
);
